export const deltaMinSwipe = 10
export const deltaMinTime = 10
